/** Verbose actionTracker / analytics logging (default off in production). */
export function isAnalyticsDebug(): boolean {
   if (typeof process !== 'undefined' && process.env.REACT_APP_ANALYTICS_DEBUG === '1') {
      return true;
   }
   if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
      return true;
   }
   return false;
}
